const obj = {
    /**
     * 结算管理
     */
    //  店铺销售结算
    getPlatStoreSettlementList: "/settlement/platform/getSettlementList",
    // 结算列表导出
    downloadExport: "/settlement/platform/export/downloadExport",
    //  订单明细列表导出
    orderDownloadExport: "/settlement/platform/orderExport/downloadExport",
    //  退款单明细列表导出
    refundDownloadExport: "/settlement/platform/refundExport/downloadExport",
    //  结算详情
    getSettlementOrderList: "/settlement/platform/getSettlementOrderList",
    //  售后订单明细
    getSettlementRefundList: "/settlement/platform/getSettlementRefundList",
    //  对账单详情
    getAccountPrint: "/settlement/platform/getSettlementDetail",
    //  商家对账单
    getStorePrint: "/settlement/store/getSettlementDetail",
    //  确认结算
    settleAccounts: "/settlement/platform/settleAccounts",
    //  确认审核
    settleApplyAccounts: "/settlement/platform/commerceCheck",
    /*店铺货款结算 */
    //查询店铺结算总单
    getSettlementList:'supply/settlement/getSettlementList',
    //查询结算订单明细数据
    getSettlementOrderListDetails:'/supply/settlement/getSettlementOrderList',
    //查询订单运费信息
    getSettlementFreightOrderList:'supply/settlement/getSettlementFreightOrderList',
    //查询退货订单数据信息
    getSettlementRefundOrderList:'/supply/settlement/getSettlementRefundOrderList',
    //供应商结算导出
    downloadExportList:'/supply/settlement/downloadExport',
    //运费订单导出
    downloadExportOrder:'/supply/settlement/freightExport/downloadExport',
    //供应商售后导出
    downloadRefundExport:'/supply/settlement/downloadRefundExport',
    //供应商订单导出
    downloadOrderExport:'/supply/settlement/downloadOrderExport',
    //打印结算订单数据
    printSupplySettlement:'/supply/settlement/printSupplySettlement/',
    //平台审核订单
    platformAudit:'/supply/settlement/platformAudit/',
    //财务审核订单
    financeAudit:'/supply/settlement/financeAudit/',
    
}
export default obj;
